import { bgColors } from "../../../utils/bgColor";
import {tilerootpath} from "../../../api_servcies/apirootpath"
const waterbodyurl = `${tilerootpath}/india_waterpoly`
export function Waterbody(map,WaterBodies,opacity){
  const source_id = "india_waterpoly"
  const layer_id =  "india_waterpoly"
  let visibility = 'visible'
  if(WaterBodies===false){
    visibility = 'none'
  }
  if (map) {
  if (map.getLayer(layer_id)) {
    map.removeLayer(layer_id);
  }
  if (map.getSource(source_id)) {
     map.removeSource(source_id);
  }
    map.addSource(`${source_id}`, {
    type: 'vector',
    "tiles": [`${waterbodyurl}/{z}/{x}/{y}.mvt`],
    "tolerance": 1,
    'minzoom': 7
    // 'maxzoom': 20,
  });
  map.addLayer({
    'id': `${source_id}`,
    'source': `${layer_id}`,
     'source-layer': `${layer_id}`,
    "type": "fill",
    'layout': {
      'visibility': visibility,
    },
    'paint': {
      "fill-color": "#00ffff",
      'fill-opacity': opacity
    }
  });
}
}

export function handleWaterbodylayer(map,WaterBodies){
  const source_id = "india_waterpoly"
  const layer_id =  "india_waterpoly"
  if(WaterBodies===false){
    if (map.getLayer(layer_id)) {
        map.removeLayer(layer_id);
      }
    if (map.getSource(source_id)) {
         map.removeSource(source_id);
      }
  }
}
